import {
  byClass,
  setStyle,
  isMobile,
  randomInt
} from './utils'

function randomRotateGifts () {
  const imageContainer = byClass('gifts-images')
  if (!imageContainer) return
  const images = imageContainer.children
  const xOffset = isMobile() ? 10 : 30
  const yOffset = isMobile() ? 5 : 10
  const imageWidth = images[0].getBoundingClientRect().width
  setStyle(imageContainer, {
    'top': `${imageWidth * Math.sqrt(2) / 2 - imageWidth / 2 + yOffset}px`
  })
  const dOffset = 30
  // Edge 不支持 DOM Collection 的迭代，故此处不能使用 for of
  for (let i = 0; i < images.length; i++) {
    const image = images[i]
    const deg = randomInt(-dOffset, dOffset)
    const x = randomInt(-xOffset, xOffset)
    const y = randomInt(-yOffset, yOffset)
    setStyle(image, {
      transform: `rotate(${deg}deg) translate(${x}px, ${y}px)`
    })
  }
}

export {
  randomRotateGifts
}
